import styles from "./Footer.module.css";

export function Footer({ onPrivacy, onChangelog }: { onPrivacy?: () => void; onChangelog?: () => void }) {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      &copy; {year} BitWyrd. All rights reserved.
      {" · "}
      <a
        href="/privacy"
        className={styles.link}
        onClick={(e) => { if (onPrivacy) { e.preventDefault(); onPrivacy(); } }}
      >
        Privacy
      </a>
      {onChangelog && (
        <>
          {" · "}
          <button className={styles.linkButton} onClick={onChangelog}>
            What's New
          </button>
        </>
      )}
    </footer>
  );
}
